import { defineComponent as _defineComponent } from 'vue'
import CBadge from '@/components/shared/CBadge';
import type { Tag } from '@/api/typings/tags';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagsCell',
  props: {
    tags: null
  },
  emits: ["manage"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'manage'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emit, CBadge }
}

})